import * as yup from "yup";
import { ValidationError } from "yup";
import { getSchema } from "./calculatorValidationSchemas";
import { CalculatorPageState } from "./models/CalculatorPageState";
import { LogLevel, logPost } from "../../api/controllers/logController/logController";

export const extractInnerValidationErrors = (validationError: yup.ValidationError): Record<string, string> | undefined => {
  if (!(validationError?.inner?.length > 0)) {
    return;
  }

  const extractedErrors: { [path: string]: string } = {};
  // TODO: Remove reverse when green component library TextInput changes value to null when input is empty.
  // reverse is needed because empty string '' is validated .required().test() and both errors are triggered. We need to display the first error from the list.
  for (const innerError of validationError.inner.reverse()) {
    if (innerError.path) {
      extractedErrors[innerError.path] = innerError.message;
    }
  }
  return extractedErrors;
};

export const validate = (state: CalculatorPageState) => {
  delete state.form.validationErrors;

  if (!state.financingStructure || !state.financingStructure.availableContractLengths) {
    logPost({ message: `Financing structure or available contract lengths are not available in state: ${JSON.stringify(state)}`, level: LogLevel.Error });
    return;
  }

  const selectedContractLengthInMonths = state.financingStructure.availableContractLengths.find((x) => x.monthsFrom === state.form.contractPeriodInMonths);
  if (!selectedContractLengthInMonths) {
    logPost({ message: `Selected contract length is not available in state: ${JSON.stringify(state)}`, level: LogLevel.Error });
    return;
  }

  const schema = getSchema(
    state.financingStructure.purchasePriceFrom,
    state.financingStructure.purchasePriceTo,
    selectedContractLengthInMonths.downPaymentRange.rangeFrom,
    selectedContractLengthInMonths.downPaymentRange.rangeTo,
    selectedContractLengthInMonths.residualValueRange.rangeFrom,
    selectedContractLengthInMonths.residualValueRange.rangeTo
  );

  try {
    schema.validateSync(state.form, { abortEarly: false });
  } catch (error) {
    if (error instanceof ValidationError) {
      state.form.validationErrors = extractInnerValidationErrors(error);
    } else {
      logPost({ message: `Unexpected error while validating the form: ${JSON.stringify(state.form)}`, level: LogLevel.Error });
    }
  }
};
